<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="740px"
    append-to-body
    :close-on-click-modal="false"
    @close="$emit('update:visible', false)"
  >
    <div v-if="detail" class="detail-container">
      <div class="section-title">基础信息</div>
      <div class="custom-desc">
        <!-- 材料信息详情 -->
        <template v-if="mode === 'material'">
          <div class="desc-row">
            <div class="desc-item">
              <div class="desc-label">材料编号</div>
              <div class="desc-value">
                <code class="highlight-code">{{ detail.materialCode || '-' }}</code>
              </div>
            </div>
            <div class="desc-item">
              <div class="desc-label">库存状态</div>
              <div class="desc-value">
                <el-tag :type="stockStatusType(detail.stockStatus)" size="small" effect="light">
                  {{ detail.stockStatusName || detail.stockStatus }}
                </el-tag>
              </div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item">
              <div class="desc-label">材料名称</div>
              <div class="desc-value">{{ detail.materialName || '-' }}</div>
            </div>
            <div class="desc-item">
              <div class="desc-label">材料类型</div>
              <div class="desc-value">
                <dict-tag :dict-type="DICT_TYPE.MATERIAL_TYPE" :value="detail.materialType" />
              </div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item">
              <div class="desc-label">计量单位</div>
              <div class="desc-value">{{ detail.unit || '-' }}</div>
            </div>
            <div class="desc-item">
              <div class="desc-label">当前库存</div>
              <div class="desc-value">{{ detail.stockCount != null ? detail.stockCount : '-' }}</div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item">
              <div class="desc-label">预警阈值</div>
              <div class="desc-value">{{ detail.warningThreshold != null ? detail.warningThreshold : '-' }}</div>
            </div>
            <div class="desc-item">
              <div class="desc-label">存放位置</div>
              <div class="desc-value">{{ detail.storageLocation || '-' }}</div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item">
              <div class="desc-label">创建人</div>
              <div class="desc-value">{{ detail.createUserName || '-' }}</div>
            </div>
            <div class="desc-item">
              <div class="desc-label">创建时间</div>
              <div class="desc-value">{{ formatDateTime(detail.createTime) }}</div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item" style="flex: 1">
              <div class="desc-label">备注</div>
              <div class="desc-value desc-value--multiline">{{ detail.remark || '-' }}</div>
            </div>
          </div>
        </template>

        <!-- 入库记录详情 -->
        <template v-else-if="mode === 'stockIn'">
          <div class="desc-row">
            <div class="desc-item">
              <div class="desc-label">材料编号</div>
              <div class="desc-value">
                <code class="highlight-code">{{ detail.materialCode || '-' }}</code>
              </div>
            </div>
            <div class="desc-item">
              <div class="desc-label">材料名称</div>
              <div class="desc-value">{{ detail.materialName || '-' }}</div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item">
              <div class="desc-label">入库数量</div>
              <div class="desc-value">{{ detail.inCount != null ? `${detail.inCount}${detail.unit || ''}` : '-' }}</div>
            </div>
            <div class="desc-item">
              <div class="desc-label">入库日期</div>
              <div class="desc-value">{{ formatDateTime(detail.inDate) }}</div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item" style="flex: 1">
              <div class="desc-label">材料来源</div>
              <div class="desc-value">{{ detail.supplier || '-' }}</div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item">
              <div class="desc-label">操作人</div>
              <div class="desc-value">{{ detail.operatorName || '-' }}</div>
            </div>
            <div class="desc-item">
              <div class="desc-label">记录时间</div>
              <div class="desc-value">{{ formatDateTime(detail.createTime) }}</div>
            </div>
          </div>
          <div class="desc-row">
            <div class="desc-item" style="flex: 1">
              <div class="desc-label">备注</div>
              <div class="desc-value desc-value--multiline">{{ detail.remark || '-' }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div slot="footer">
      <el-button @click="$emit('update:visible', false)">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 工具函数
import { DICT_TYPE } from '@/features/components/dict/dictTypeKeys';
import { formatDateTime } from '@/features/common/utils/dateTimeUtil.js';

export default {
  name: 'MaterialDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: null
    },
    /** material：材料台账；stockIn：入库记录 */
    mode: {
      type: String,
      default: 'material'
    }
  },
  data() {
    return { DICT_TYPE };
  },
  computed: {
    dialogTitle () {
      if (this.mode === 'stockIn') return '入库记录详情';
      return '材料详情';
    },
  },
  methods: {
    formatDateTime,
    stockStatusType (status) {
      const map = { sufficient: 'success', warning: 'warning', low: 'danger' };
      return map[status] || 'info';
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-container {
  padding: 0 4px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 14px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1.1;
}

.custom-desc {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
  font-size: 14px;
  background: #fff;
}

.desc-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    border-bottom: none;
  }
}

.desc-item {
  display: flex;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  border-right: 1px solid #ebeef5;

  &:last-child {
    border-right: none;
  }
}

.desc-label {
  width: 110px;
  background-color: #f8f9fb;
  color: #606266;
  padding: 10px 12px;
  box-sizing: border-box;
  font-weight: 500;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.desc-value {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  color: #303133;
  box-sizing: border-box;
  word-break: break-all;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.desc-value--multiline {
  white-space: pre-wrap;
  line-height: 1.6;
  align-items: flex-start;
  padding-top: 5px;
  padding-bottom: 5px;
}

.highlight-code {
  color: #409eff;
  background: #ecf5ff;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: monospace;
}
</style>
